module.exports = __webpack_public_path__ + "img/hermes_03.520b4a18.jpg";